/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumUpdateStatoRichiestaRequestStato =
  (typeof EnumUpdateStatoRichiestaRequestStato)[keyof typeof EnumUpdateStatoRichiestaRequestStato];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumUpdateStatoRichiestaRequestStato = {
  CREATA: 'CREATA',
  BOZZA: 'BOZZA',
  IN_INVIO: 'IN_INVIO',
  INVIATA: 'INVIATA',
  INTEGRATA: 'INTEGRATA',
  CANCELLATA: 'CANCELLATA',
  RICEVUTA: 'RICEVUTA',
  CONCLUSA: 'CONCLUSA',
  PAGAMENTO: 'PAGAMENTO',
} as const;
